<template>
  <div class="user-info-wrapper">
    <div class="header">个人信息</div>
    <div class="content">
      <div class="info-item">
        <span class="key">姓名：</span>
        <span class="value">{{userInfo.username}}</span>
        <span class="edit" @click="editNameVisble = true">
          <i class="iconfont iconbianji"></i>修改
        </span>
      </div>
      <div class="info-item">
        <span class="key">公司名称：</span>
        <span class="value">{{userInfo.company}}</span>
      </div>
      <div class="info-item">
        <span class="key">邮箱：</span>
        <span class="value">{{userInfo.email}}</span>
        <span class="edit" @click="editEmailVisble=true">
          <i class="iconfont iconbianji"></i>修改
        </span>
      </div>
      <p
        class="info-item tip-active"
        v-if="istipActiveEmail"
      >请前往{{tipActiveEmail}}激活邮箱，激活成功后邮箱修改为{{tipActiveEmail}}</p>
      <alert-email-configure :user-email="userInfo.email"></alert-email-configure>
      <div class="info-item" style="margin-bottom:24px;">
        <span class="key">手机号：</span>
        <span class="value">{{userInfo.phone}}</span>
        <span class="edit" @click="editPhoneVisble=true">
          <i class="iconfont iconbianji"></i>修改
        </span>
      </div>
      <div class="btn-group">
        <div class="btn" @click="editPasswordVisble=true">修改密码</div>
        <div class="btn" @click="logout">退出账号</div>
      </div>
    </div>
    <el-dialog :visible.sync="editNameVisble" width="560px" :show-close="false">
      <div class="dialog-content">
        <i class="iconfont iconguanbi close" @click="editNameVisble=false"></i>
        <div class="dialog-header">修改姓名</div>
        <div class="content-wrapper">
          <div class="edit-form">
            <span class="label">姓名</span>
            <el-input placeholder="请输入姓名" v-model.trim="name" @focus="editNameTip =''"></el-input>
            <p class="edit-tip">{{editNameTip}}</p>
          </div>
          <div class="btn-group">
            <div class="btn" @click="editNameVisble=false">取消</div>
            <div class="btn" @click="submitEditName">提交</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editEmailVisble" width="560px" :show-close="false">
      <div class="dialog-content">
        <i class="iconfont iconguanbi close" @click="editEmailVisble=false"></i>
        <div class="dialog-header">修改邮箱</div>
        <div class="content-wrapper">
          <div class="email-text">
            <span class="label">原邮箱</span>
            <span>{{userInfo.email}}</span>
          </div>
          <div class="edit-form">
            <span class="label">新邮箱</span>
            <el-input placeholder="请输入邮箱" v-model.trim="email" @focus="editEmailTip =''"></el-input>
            <p class="edit-tip">{{editEmailTip}}</p>
          </div>
          <div class="btn-group">
            <div class="btn" @click="editEmailVisble=false">取消</div>
            <div class="btn" @click="submitEditEmail">提交</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editPhoneVisble" width="560px" :show-close="false">
      <div class="dialog-content">
        <i class="iconfont iconguanbi close" @click="editPhoneVisble=false"></i>
        <div class="dialog-header">修改手机号</div>
        <div class="content-wrapper">
          <div class="edit-item">
            <span class="label">原手机号</span>
            <span>{{userInfo.phone}}</span>
          </div>
          <div class="edit-item">
            <span class="label">新手机号</span>
            <el-input placeholder="请输入手机号" v-model.trim="phone" @input.native="phoneInput($event)"></el-input>
            <div
              class="get-code-btn"
              :class="{'disabled':codeBtnDisabled}"
              @click="getImageCode"
            >{{codeBtnText}}</div>
            <p class="phone-tip">{{editPhoneTip}}</p>
          </div>
          <div class="edit-item">
            <span class="label">验证码</span>
            <el-input placeholder="请输入验证码" v-model.trim="code" @input.native="codeInput($event)"></el-input>
            <p class="phone-tip">{{codeErrTip}}</p>
          </div>
          <div class="btn-group">
            <div class="btn" @click="editPhoneVisble=false">取消</div>
            <div
              class="btn"
              @click="submitEditPhone"
              :class="{'edit-phone-btn-disabled':submitBtnDisabled}"
            >提交</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="editPasswordVisble" width="560px" :show-close="false">
      <div class="dialog-content">
        <i class="iconfont iconguanbi close" @click="editPasswordVisble=false"></i>
        <div class="dialog-header">修改密码</div>
        <div class="content-wrapper">
          <div class="edit-item">
            <span class="label">原密码</span>
            <el-input placeholder="请输入原密码" v-model="oldPassword" type="password"></el-input>
            <p class="phone-tip">{{oldPassErrTip}}</p>
          </div>
          <div class="edit-item">
            <span class="label">新密码</span>
            <el-input placeholder="请输入新密码" v-model="password" type="password"></el-input>
            <p class="phone-tip">{{passwordErrTip}}</p>
          </div>
          <div class="edit-item" style="margin-bottom:50px;">
            <span class="label">确认密码</span>
            <el-input placeholder="请再次输入密码" v-model="checkPass" type="password"></el-input>
            <p class="phone-tip">{{checkPassErrTip}}</p>
          </div>
          <div class="btn-group edit-password">
            <p class="tip">{{submitPasswordErrTip}}</p>
            <div class="btn" @click="editPasswordVisble=false">取消</div>
            <div class="btn" @click="submitEditPassword">提交</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateSelf, getMyself, emailChange, tencentCaptcha, getSmsCaptha, phoneChange, checkSmsCaptha } from '@/services/interface'
import weakPassword from '../../login/weakPassword.js'
import http from '@/services/http'
import { api } from '@/services/api'
import { encryptData } from '@/util/encrypt'
import AlertEmailConfigure from './alertEmailConfigure.vue'
export default {
  components: {
    AlertEmailConfigure
  },
  data () {
    return {
      editNameVisble: false,
      name: '', // 修改姓名输入框
      editNameTip: '', // 修改姓名输入框错误提示
      editEmailVisble: false,
      email: '', // 修改邮箱输入框
      editEmailTip: '', // 修改邮箱输入框错误提示
      istipActiveEmail: false, // 是否提示激活
      tipActiveEmail: '', // 修改邮箱成功后存储新邮箱提示
      editPhoneVisble: false,
      phone: '', // 修改手机号输入框
      codeBtnDisabled: true, // 获取验证码按钮禁用
      codeBtnText: '获取验证码', // 获取验证码按钮文字
      editPhoneTip: '', // 修改手机号输入框错误提示
      code: '', // 修改手机号验证码
      submitBtnDisabled: true, // 提交按钮禁用
      codeErrTip: '', // 验证码输入错误提示
      editPasswordVisble: false,
      oldPassword: '', // 原密码输入框
      password: '', // 新密码输入框
      checkPass: '', // 确认密码输入框
      oldPassErrTip: '', // 修改密码原密码输入框错误提示
      passwordErrTip: '', // 修改密码新密码输入框错误提示
      checkPassErrTip: '', // 修改密码确认密码输入框错误提示
      submitPasswordErrTip: '' // 修改密码后端返回错误
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user
    }
  },
  methods: {
    /**
     * 编辑名字提交
     */
    async submitEditName () {
      if (!this.name) {
        this.editNameTip = '请输入姓名'
        return
      }
      if (this.name.length < 2 || this.name.length > 18) {
        this.editNameTip = '字符长度请保持在2-18位'
      }
      const data = {
        username: this.name
      }
      const res = await updateSelf(data)
      if (res.status === 200) {
        await this.refreshInfo()
        this.editNameVisble = false
        this.name = ''
      }
    },

    /**
     *编辑邮箱提交
     */
    async submitEditEmail () {
      if (!this.email) {
        this.editEmailTip = '请输入邮箱'
        return
      }
      if (!/^([A-Za-z0-9_+-.])+@([A-Za-z0-9\-.])+\.([A-Za-z]{2,22})$/.test(this.email)) {
        this.editEmailTip = '邮箱格式错误'
        return
      }
      if (this.email === this.userInfo.email) {
        this.editEmailTip = '与原邮箱相同'
        return
      }
      const data = {
        email: this.email
      }
      await emailChange(data).then(res => {
        if (res.status === 200) {
          this.istipActiveEmail = true
          this.editEmailVisble = false
          this.$message({ message: `请前往${this.email}激活邮箱`, duration: '4000', type: 'success' })
          this.tipActiveEmail = this.email
          this.email = ''
        }
      }).catch(err => {
        if (err.data.type === 10002) {
          this.editEmailTip = '新邮箱已存在,请使用其他邮箱'
        }
        if (err.data.type === 10017) {
          this.editEmailTip = '邮箱不可为临时邮箱'
        }
      })
    },

    /**
     * 编辑手机号输入框输入事件
     */
    phoneInput (e) {
      this.inputTime = e.timeStamp
      this.editPhoneTip = ''
      setTimeout(() => {
        if ((this.inputTime - e.timeStamp) === 0) { // this.inputTime拿的是最新的值，e.timeStamp拿的是零点五秒前函数的e.timeStamp
          if (!this.phone) {
            this.editPhoneTip = '请输入手机号'
            this.codeBtnDisabled = true
          } else if (!/^1[3456789]\d{9}$/.test(this.phone)) {
            this.editPhoneTip = '手机号格式错误'
            this.codeBtnDisabled = true
          } else if (this.phone === this.userInfo.phone) {
            this.editPhoneTip = '新手机号与原手机号相同'
            this.codeBtnDisabled = true
          } else {
            this.editPhoneTip = ''
            this.codeBtnDisabled = false
          }
        }
      }, 500)
    },

    /**
     * 获取腾讯验证码验证码图片
     */
    getImageCode () {
      const captcha1 = new TencentCaptcha(this.$constants.APP_ID_MAP.PHONE, (res) => this.sucessTencentCatpcha(res))
      captcha1.show() // 显示验证码
    },

    /**
     * 验证腾讯验证码
     */
    async sucessTencentCatpcha (res) {
      if (res.ticket) {
        const param = {
          name: 'phone-captcha',
          ticket: res.ticket,
          nonce: res.randstr
        }
        const response = await tencentCaptcha(param)
        if (response.status === 200) {
          this.getCode()
        }
      }
    },

    /**
     * 发送验证码
     */
    async getCode () {
      let time = 60
      const data = { phone: this.phone, name: 'user-phone-change' }
      const res = await getSmsCaptha(data)
      if (res.status === 200) {
        this.codeBtnDisabled = true
        this.timer = setInterval(() => {
          this.codeBtnText = `(${time}s)重新获取`
          time--
          if (time <= 0) {
            clearInterval(this.timer)
            this.codeBtnText = '重新获取'
            this.codeBtnDisabled = false
          }
        }, 1000)
      }
    },

    /**
     * 编辑手机号验证码输入框输入事件
     */
    codeInput (e) {
      this.inputTime = e.timeStamp
      this.codeErrTip = ''
      setTimeout(async () => {
        if (this.inputTime - e.timeStamp === 0) {
          if (this.code.length === 6) {
            const data = { token: this.code, phone: this.phone, name: 'user-phone-change' }
            await checkSmsCaptha(data).then(res => {
              if (res.status === 200) {
                this.codeErrTip = ''
                this.submitBtnDisabled = false
              } else {
                this.codeErrTip = '验证码错误'
                this.submitBtnDisabled = true
              }
            }).catch(() => {
              this.codeErrTip = '验证码错误'
              this.submitBtnDisabled = true
            })
          } else {
            this.codeErrTip = '验证码错误'
            this.submitBtnDisabled = true
          }
        }
      }, 500)
    },

    /**
     * 编辑手机号提交
     */
    async submitEditPhone () {
      const data = {
        phone: this.phone
      }
      await phoneChange(data).then(async res => {
        if (res.status === 200) {
          await this.refreshInfo()
          this.editPhoneVisble = false
          this.phone = ''
          this.code = ''
          this.$message.success('修改成功')
        }
      }).catch(err => {
        if (err.data.type === 10002) {
          this.editPhoneTip = '手机号已存在,请使用其他手机号'
        }
      })
    },

    /**
     * 检测修改密码输入
     */
    checkPassFn () {
      this.oldPassErrTip = this.passwordErrTip = this.checkPassErrTip = ''
      let flag = true
      if (!this.oldPassword) {
        this.oldPassErrTip = '请输入原密码'
        flag = false
      }
      if (!this.password) {
        this.passwordErrTip = '请输入新密码'
        flag = false
      } else if (this.password < 8) {
        this.passwordErrTip = '密码长度请保持在8位以上'
        flag = false
      } else if (/^[0-9]+$/.test(this.password)) {
        this.passwordErrTip = '密码不能为纯数字'
        flag = false
      } else if (/^[a-zA-Z]+$/.test(this.password)) {
        this.passwordErrTip = '密码不能为纯字母'
        flag = false
      } else if (weakPassword.includes(this.password)) {
        this.passwordErrTip = '密码强度低，请避免使用生日、姓名、连续数字或字母等'
      }
      if (!this.checkPass) {
        this.checkPassErrTip = '请再次输入密码'
        flag = false
      } else if (this.checkPass !== this.password) {
        this.checkPassErrTip = '两次密码输入不一致'
        flag = false
      }
      return flag
    },

    /**
     * 修改密码提交
     */
    async submitEditPassword () {
      this.submitPasswordErrTip = ''
      if (!this.checkPassFn()) {
        return
      }
      const encryptPwd = encryptData(this.password)
      const params = {
        password: encryptData(this.oldPassword),
        new_password: encryptPwd,
        new_password_again: encryptPwd
      }
      const res = await http.patch(api.user.PASSWORD_CHANGE(), params)
      switch (res) {
        case 200:
          this.editPasswordVisble = false
          this.$store.commit('login', false)
          this.$store.commit('getPermissions', [])
          this.$store.commit('getEmail', '')
          this.$store.commit('getProductLoading', false)
          this.alert()
          break
        default:
          this.submitPasswordErrTip = res
      }
    },

    /**
     * 修改密码成功提示
     */
    async alert () {
      let t = 5
      this.$message({
        dangerouslyUseHTMLString: true,
        message: '密码修改成功，<span id=\'second\'>5</span>秒后将退出登录，需以新密码重新登录',
        type: 'success',
        duration: 5000
      })
      const timer = await setInterval(() => {
        t--
        document.getElementById('second').innerHTML--
        if (t === 0) {
          clearInterval(timer)
          this.$router.push({ path: '/login' })
        }
      }, 1000)
    },

    /**
     *  退出账号
     */
    async logout () {
      const res = await http.get(api.user.LOGOUT())
      if (res === 200) {
        this.$store.commit('login', false)
        this.$store.commit('getPermissions', [])
        this.$store.commit('getEmail', '')
        this.$store.commit('getProductLoading', false)
        this.$router.push({ path: '/login' })
      }
    },

    /**
     * 刷新用户信息
     */
    async refreshInfo () {
      await getMyself().then((res) => {
        if (res.status === 200) {
          this.$store.commit('getUser', res.data)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-wrapper {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog__body {
    padding: 0;
    .dialog-content {
      position: relative;
      i.close {
        position: absolute;
        right: 20px;
        top: 18px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }
      .dialog-header {
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #fff;
        font-size: 16px;
        background: rgba(0, 61, 146, 1);
      }
      .content-wrapper {
        padding: 50px 60px 30px;
        .btn-group {
          display: flex;
          justify-content: space-between;
          &.edit-password {
            position: relative;
            .tip {
              position: absolute;
              right: 0;
              top: -30px;
              font-size: 14px;
              color: #ef3b45;
              line-height: 20px;
            }
          }
          .btn {
            width: 150px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            color: #fff;
            cursor: pointer;
            font-size: 14px;
            box-sizing: border-box;
            border-radius: 4px;
            &:nth-of-type(1) {
              border: 1px solid #dcdfe6;
              color: #b8bac7;
            }
            &:nth-of-type(2) {
              background: rgba(0, 61, 146, 1);
            }
          }
        }
      }
    }
  }
  .header {
    height: 62px;
    line-height: 62px;
    padding-left: 24px;
    border-bottom: 1px solid #e6e7f0;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 500;
    color: rgba(29, 36, 60, 1);
  }
  .content {
    padding: 18px 24px 31px;
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(29, 36, 60, 1);
      line-height: 20px;
      .key {
        width: 70px;
        margin-right: 8px;
      }
      .value {
        width: 200px;
        margin-right: 10px;
      }
      .edit {
        color: #003d92;
        cursor: pointer;
      }
      &.tip-active {
        margin-top: -10px;
        font-size: 13px;
        color: #6f799c;
      }
    }
    .btn-group {
      display: flex;
      .btn {
        width: 104px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #fff;
        font-weight: 400;
        border-radius: 4px;
        margin-right: 24px;
        cursor: pointer;
        box-sizing: border-box;
        &:nth-of-type(1) {
          background: rgba(0, 61, 146, 1);
        }
        &:nth-of-type(2) {
          border: 1px solid rgba(0, 61, 146, 1);
          color: #003d92;
        }
      }
    }
  }
  .edit-form {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 60px;
    .label {
      color: #404964;
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      margin-right: 20px;
    }
    .edit-tip {
      position: absolute;
      right: 0;
      top: 45px;
      font-size: 14px;
      color: #ef3b45;
      line-height: 20px;
    }
  }
  .email-text {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .label {
      color: #404964;
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      margin-right: 20px;
    }
  }
  .edit-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    position: relative;
    .label {
      color: #404964;
      font-size: 14px;
      font-weight: bold;
      white-space: nowrap;
      margin-right: 20px;
      width: 56px;
    }
    .el-input {
      flex: 1;
    }
    .get-code-btn {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      background: #003d92;
      border-radius: 4px;
      margin-left: 10px;
      color: #fff;
      font-size: 14px;
      &.disabled {
        background: #d6d7dc;
        pointer-events: none;
      }
    }
    .phone-tip {
      position: absolute;
      right: 0;
      top: 45px;
      font-size: 14px;
      color: #ef3b45;
      line-height: 20px;
    }
  }
  .edit-phone-btn-disabled {
    background: #d6d7dc !important;
    pointer-events: none;
  }
}
</style>
